import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.timers";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
// Vendor libs
import React, { useState, useEffect } from 'react';
import axios from 'axios'; // Material UI

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles'; // Material UI Icons

import DialogIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';
var useStyles = makeStyles(function (_theme) {
  return {
    span: {
      display: 'flex',
      alignItems: 'center'
    },
    icon: {
      marginRight: 15,
      marginTop: -2,
      color: 'steelblue'
    },
    iconRed: {
      marginRight: 15,
      marginTop: -2,
      color: 'red'
    },
    button: {
      marginLeft: 20
    },
    error: {
      color: 'red'
    }
  };
});
export var CheckAuthSession = function CheckAuthSession() {
  var _Config, _Config$base, _Config2, _Config2$base, _Config3, _Config3$oauth, _Config4, _Config4$oauth;

  var classes = useStyles();

  var _useState = useState(true),
      isAuthenticated = _useState[0],
      setIsAuthenticated = _useState[1];

  var _useState2 = useState(false),
      isCloseToBeExpired = _useState2[0],
      setCloseToBeExpired = _useState2[1];

  var _useState3 = useState(0),
      diffValue = _useState3[0],
      setDiffValue = _useState3[1];

  var _useState4 = useState(false),
      shouldSessionBeExtended = _useState4[0],
      setShouldSessionBeExtended = _useState4[1];

  var _useState5 = useState(''),
      error = _useState5[0],
      setError = _useState5[1];

  var expireName = 'sessionExpireTime';
  var expireMinutes = ((_Config = Config) == null ? void 0 : (_Config$base = _Config.base) == null ? void 0 : _Config$base.expireMinutes) || 5;
  var intervalMilliSeconds = ((_Config2 = Config) == null ? void 0 : (_Config2$base = _Config2.base) == null ? void 0 : _Config2$base.intervalMilliSeconds) || 60000;
  var authNotDisabled = !((_Config3 = Config) == null ? void 0 : (_Config3$oauth = _Config3.oauth) == null ? void 0 : _Config3$oauth.disabled) || ((_Config4 = Config) == null ? void 0 : (_Config4$oauth = _Config4.oauth) == null ? void 0 : _Config4$oauth.disabled.toString()) !== 'true';

  var reLogin = function reLogin() {
    localStorage.removeItem(expireName);
    window.location.reload();
  };

  var setNewExpirationDate = function setNewExpirationDate() {
    return new Promise(function (resolve) {
      return axios.get('/auth/user/me').then(function (jsonResponse) {
        localStorage.removeItem(expireName);
        var seconds = jsonResponse.data.authorities[0].client.accessTokenValiditySeconds;
        var newDate = new Date(new Date().getTime() + seconds * 1000);
        localStorage.setItem(expireName, newDate.toString());
        resolve();
      });
    });
  };

  var extendSession = function extendSession() {
    setCloseToBeExpired(false);
    setShouldSessionBeExtended(true);
    localStorage.setItem('sessionExtended', 'true');
    axios.get('/auth/refresh')["catch"](function () {
      setError('Cannot extend session');
      setCloseToBeExpired(false);
    });
  };

  useEffect(function () {
    var shouldSessionBeExtendedStorage = localStorage.getItem('sessionExtended');

    if (shouldSessionBeExtendedStorage === 'true') {
      setNewExpirationDate().then(function () {
        setShouldSessionBeExtended(false);
        localStorage.removeItem('sessionExtended');
        setError('');
        setCloseToBeExpired(false);
      });
    } else {
      var currentSessionExpireTime = localStorage.getItem(expireName);
      var diff = 0;
      var interval = setInterval(function () {
        if (currentSessionExpireTime) {
          var dateNow = new Date();
          var dateStorage = new Date(currentSessionExpireTime);
          diff = (dateStorage.getTime() - dateNow.getTime()) / 1000 / 60;
          setDiffValue(diff);

          if (diff <= expireMinutes) {
            setCloseToBeExpired(true);
            clearInterval(interval);
          }
        } else {
          setNewExpirationDate().then(function () {
            setError('');
            setCloseToBeExpired(false);
          });
        }
      }, intervalMilliSeconds);

      var checkAuth = /*#__PURE__*/function () {
        var _checkAuth2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var req;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return axios.get(Config.base.userInfoPath);

                case 3:
                  req = _context.sent;
                  return _context.abrupt("return", req.status === 200);

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](0);
                  return _context.abrupt("return", false);

                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 7]]);
        }));

        function _checkAuth() {
          return _checkAuth2.apply(this, arguments);
        }

        return _checkAuth;
      }();

      checkAuth().then(function (res) {
        return setIsAuthenticated(res);
      });
      return function () {
        return clearInterval(interval);
      };
    }
  }, [diffValue, expireMinutes, intervalMilliSeconds, shouldSessionBeExtended]);

  var modalDialog = function modalDialog(contentText, dialogActions, headerIcon, headerText, onClose, openCondition) {
    return /*#__PURE__*/React.createElement(Dialog, {
      "aria-describedby": "alert-dialog-description",
      "aria-labelledby": "alert-dialog-title",
      disableEscapeKeyDown: true,
      open: openCondition,
      onClose: onClose
    }, /*#__PURE__*/React.createElement(DialogTitle, {
      id: "alert-dialog-title"
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.span
    }, headerIcon, headerText)), /*#__PURE__*/React.createElement(DialogContent, null, error.length ? /*#__PURE__*/React.createElement("div", {
      className: classes.error
    }, error) : null, /*#__PURE__*/React.createElement(DialogContentText, {
      id: "alert-dialog-description"
    }, contentText)), /*#__PURE__*/React.createElement(DialogActions, null, dialogActions));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, modalDialog('Your session expired. Please login.', /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: reLogin
  }, "Login")), /*#__PURE__*/React.createElement(WarningIcon, {
    className: classes.iconRed
  }), 'Session Information', reLogin, !isAuthenticated && authNotDisabled), modalDialog(diffValue > 1 ? "Your session will expire in " + Math.round(diffValue) + " minutes." : diffValue === 1 ? 'Your session will expire in one minute.' : diffValue < 1 ? 'Your session will expire in less than one minute.' : 'Your session expired.', /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: function onClick() {
      setCloseToBeExpired(false);
    }
  }, "OK"), diffValue > 0 && /*#__PURE__*/React.createElement(Button, {
    className: classes.button,
    color: "primary",
    onClick: extendSession
  }, "Extend Session")), /*#__PURE__*/React.createElement(DialogIcon, {
    className: classes.icon
  }), 'Session Information', function () {
    return setCloseToBeExpired(false);
  }, isAuthenticated && isCloseToBeExpired && authNotDisabled));
};